define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/AggregateController"
], function(array, declare, lang, AggregateController) {

	return declare(AggregateController, {
		bOmitGoToDialog: true,

		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			var fd = this.inherited(arguments);
			fd.m_fAggregateSelected = lang.hitch(this, this._isPreSelected);
			return fd;
		},

		_isPreSelected: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: if name is in list then pre-select
			var node = this._getAggregateRootNode();
			var name = ctx.getNode().$Name;
			var values = node[this.m_action.aggregateId];
			return array.indexOf(values, name) >= 0;
		},

		_processNode: function(/*Node*/node, /*Boolean*/bChecked) {
			// summary: return name for node
			return node.$Name;
		},

		/**
		 * @override
		 * Overwrite full attribute value rather than do normal aggregate add/remove individual values.
		 * This is for a stringlist attribute that will have just a few selections and updated very infrequently.
		 * The normal behavior does not work because we are selecting string values rather than refs.
		 */
		_toWriterAttribute() {
			this.m_writer.changeNode(this.m_urlNode).changeAttribute(this.heading.m_id, this.heading.getAttrType(), this.newValue);
		}
	});
});